import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class ModifyBodyContactsInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const urlPattern = /^\/api\/contact-manager\/client-api\/v2\/contacts\/[0-9a-fA-F\-]{36}$/;

    // Verifica si es una solicitud GET y si la URL coincide con el patrón para modificar el request
    if (request.method === 'PUT' && urlPattern.test(request.url)) {
      request = request.clone({
        body: this.modifyBody(request.body)
      });
    }

    return next.handle(request).pipe(
      map(event => {
        if (event instanceof HttpResponse && urlPattern.test(request.url)) {
          event = event.clone({ body: this.modifyBody(event.body) });
        }
        return event;
      })
    );
  }

  modifyBody(body: any): any {
    if (body) {
      if (body.country === "") {
        body.country = null;
      }
      if (body.accounts && body.accounts.length > 0 && body.accounts[0].bankCountry === "") {
        body.accounts[0].bankCountry = null;
      }
    }
    return body;
  }
}
